import React from 'react';
import { string } from 'prop-types';
import { ErrorLabel } from '@eika/label';

function ErrorMessage({ text }) {
    if (!text) {
        return null;
    }
    return <ErrorLabel text={text} role="alert" className="input-error-message" />;
}

ErrorMessage.propTypes = {
    text: string,
};

export default ErrorMessage;
